import { useEffect, type VFC } from 'react'

import { LOGIN_OTP_STATE } from 'shared/consts'
import type { PageProperties } from 'types/pageProperties'
import { usePageProperties } from 'views/utils/shopAndRuntimeConfigUtils'

import OneTimePasswordInputForm from './OneTimePasswordInputForm'
import OneTimePasswordRequestForm from './OneTimePasswordRequestForm'

const OneTimePasswordLoginContent: VFC = () => {
  const { loginOtpState } = usePageProperties() as PageProperties & {
    loginOtpState: LOGIN_OTP_STATE
  }

  useEffect(() => {
    // Dispatch hydration event because FC will not work before hydration on a hydrated page
    const event = new CustomEvent('OneTimePasswordLoginContentHydrated')
    window.dispatchEvent(event)
  }, [])

  const renderSwitch = (otpState: LOGIN_OTP_STATE) => {
    switch (otpState) {
      case LOGIN_OTP_STATE.OTP_REQUEST:
        return <OneTimePasswordRequestForm />
      case LOGIN_OTP_STATE.OTP_REQUEST_NEW_EMAIL:
      case LOGIN_OTP_STATE.OTP_REQUEST_NEW_CODE:
        return <OneTimePasswordRequestForm isReRequest />
      case LOGIN_OTP_STATE.OTP_INPUT:
        return <OneTimePasswordInputForm />
      default:
        return <OneTimePasswordRequestForm />
    }
  }

  return <>{renderSwitch(loginOtpState)}</>
}

export default OneTimePasswordLoginContent
